module.exports = "<p>\n  print-allotment letter Page!\n</p>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/allocation/print-allotmentletter/print-allotmentletter.component.html
// module id = ./src/app/allocation/print-allotmentletter/print-allotmentletter.component.html
// module chunks = main